import { IAppItem, IClientData } from "@/Models/ApiModels";
import { ERRORS_ITEMS } from "@/Pages/CreateCampaignPage/Constants/ErrorsContants";
import {
  getTotalOrderCost,
  validationFinalOrderForm,
} from "@/Pages/CreateCampaignPage/Helpers/CreateOrderHelpers";
import { INewCampaignObject } from "@/Pages/CreateCampaignPage/Models/CountryModel";
import { throwNewToastError } from "@/Utils/MainUtils";
import { TNewOrderAttributes, TNewOrderCountry } from "@/entities/new-order";
import { getAppStore } from "@/shared/helpers/app-link.helper";

type TValidationParams = {
  orderObject: INewCampaignObject;
  delayedStartEnabled: boolean;
  delayedStartValue: string | null;
  app: IAppItem | null;
  user: IClientData | null;
  countriesList: TNewOrderCountry[];
  attributesList: TNewOrderAttributes[];
};

/**
 * Валидация заказа перед отправкой на сервер
 * @returns true если валидация прошла успешно, false если есть ошибки
 */
export const validateOrder = ({
  orderObject,
  delayedStartEnabled,
  delayedStartValue,
  app,
  user,
  countriesList,
  attributesList,
}: TValidationParams): boolean => {
  const errorsList = validationFinalOrderForm(
    orderObject,
    getAppStore(app?.url || "apple"),
  );

  // Проверка отложенного старта
  if (delayedStartEnabled && !delayedStartValue) {
    errorsList.push("delayed_start_empty");
  }

  // Проверка баланса
  if (app && user && orderObject.type) {
    const totalCost = getTotalOrderCost(
      app,
      user,
      countriesList,
      orderObject.type,
      attributesList,
    );

    if (totalCost && totalCost > user.balance - user.limit) {
      errorsList.push("error_lack_money");
    }
  }

  // Отображение ошибок
  if (errorsList.length > 0) {
    errorsList.forEach((error) => throwNewToastError(ERRORS_ITEMS[error]));
    return false;
  }

  return true;
};
